/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APITicketAutocompleteSuggestion
 */
export interface APITicketAutocompleteSuggestion {
    /**
     * 
     * @type {string}
     * @memberof APITicketAutocompleteSuggestion
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof APITicketAutocompleteSuggestion
     */
    subject: string;
    /**
     * 
     * @type {string}
     * @memberof APITicketAutocompleteSuggestion
     */
    userEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof APITicketAutocompleteSuggestion
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof APITicketAutocompleteSuggestion
     */
    type?: string;
}

/**
 * Check if a given object implements the APITicketAutocompleteSuggestion interface.
 */
export function instanceOfAPITicketAutocompleteSuggestion(value: object): value is APITicketAutocompleteSuggestion {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('subject' in value) || value['subject'] === undefined) return false;
    return true;
}

export function APITicketAutocompleteSuggestionFromJSON(json: any): APITicketAutocompleteSuggestion {
    return APITicketAutocompleteSuggestionFromJSONTyped(json, false);
}

export function APITicketAutocompleteSuggestionFromJSONTyped(json: any, ignoreDiscriminator: boolean): APITicketAutocompleteSuggestion {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'subject': json['subject'],
        'userEmail': json['user_email'] == null ? undefined : json['user_email'],
        'status': json['status'] == null ? undefined : json['status'],
        'type': json['type'] == null ? undefined : json['type'],
    };
}

export function APITicketAutocompleteSuggestionToJSON(value?: APITicketAutocompleteSuggestion | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'subject': value['subject'],
        'user_email': value['userEmail'],
        'status': value['status'],
        'type': value['type'],
    };
}

